type IconProps = React.HTMLAttributes<SVGElement>;

export const CloseIcon = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none" {...props}>
    <path
      d="M13.8875 6.91135C14.2457 6.56881 14.2457 6.01253 13.8875 5.66999C13.5293 5.32745 12.9476 5.32745 12.5895 5.66999L9.57218 8.55828L6.55202 5.67273C6.19384 5.33019 5.61216 5.33019 5.25398 5.67273C4.89581 6.01527 4.89581 6.57155 5.25398 6.91409L8.27414 9.79964L5.25685 12.6879C4.89867 13.0305 4.89867 13.5868 5.25685 13.9293C5.61503 14.2718 6.19671 14.2718 6.55489 13.9293L9.57218 11.041L12.5923 13.9265C12.9505 14.2691 13.5322 14.2691 13.8904 13.9265C14.2485 13.584 14.2485 13.0277 13.8904 12.6852L10.8702 9.79964L13.8875 6.91135Z"
      fill="#ECECEC"
    />
  </svg>
);
